import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import GetReport from "src/components/getReport";
import { FormProvider, RHFSelect } from "src/components/hook-form";
import Users from "src/components/users";
import useRanks from "../hooks/use-ranks";
import Map from "src/components/map";
const DataFilter = ({  methods, onFilter }) => {
  const { t } = useTranslation();
  const ranks = useRanks();
  return (
    <>
      <Grid item xs={12} md={12} sx={{ p: 2, mb: 2, mt: 1 }}>
        <FormProvider methods={methods} onSubmit={onFilter}>
          <Box
            sx={{
              display: "grid",
              columnGap: 2,
              rowGap: 3,
              gridTemplateColumns: {
                xs: "repeat(1, 1fr)",
                sm: "repeat(5, 1fr)",
              },
            }}
          >
           
            {/* <Users  label="global.username" name="user_id" size="small" /> */}
            <RHFSelect name="rank_id" label={"search.Rank"} size="small">
              <option value="" />

              <Map
                list={ranks}
                render={({ rank_name, id }) => (
                  <option value={id}>{rank_name}</option>
                )}
              />
            </RHFSelect>
            <GetReport size="medium" />
          </Box>
        </FormProvider>
      </Grid>
    </>
  );
};

export default DataFilter;
